<script setup lang="ts">
import store from "@/store";
import PassCard from "@/components/RegistrationPage/Card/MobileVersion/PassCard.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'SubscriptionsHolder',
})
</script>

<template>
    <div class="options">
        <PassCard
            v-for="(pass, i) in store.state.passes"
            :key="i"
            :pass="pass"
        />
    </div>
</template>

<style scoped lang="scss">
.options {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: center;
    align-items: center;
}
</style>
